import { useTranslations } from 'next-intl'
import { FilterRadio } from './filter-radio'

type Props = {
  value: string
  onFilterChange: (value: string) => void
}

export const FilterOutlet = ({ value, onFilterChange }: Props) => {
  const t = useTranslations('collection_page')
  const outletList = [
    {
      key: '30',
      label: t('title.discount30'),
    },
    {
      key: '50',
      label: t('title.discount50'),
    },
  ]

  return (
    <FilterRadio
      value={value}
      onFilterChange={onFilterChange}
      items={outletList.map((item) => ({
        value: item.key,
        label: item.label,
      }))}
    />
  )
}
